import { ErrorResponse } from 'src/infrastructure/rest-api/api-types';

export class HttpStatusError extends Error {
    constructor(
        public status: number,
        public statusText: string,
        public body: ErrorResponse | string | undefined = undefined
    ) {
        super(`HTTP status ${status}: ${statusText}`);
        this.name = 'HttpStatusError';
    }
}
